import React, { useState, useEffect } from "react";
import "./styles.ts";
import { Input } from "../../../../../components/Input";
import { Button } from "../../../../../components/Button";
import { ReactComponent as Voltar } from "../../../../../assets/newImages/icons/angle-down.svg";
import { categoriasApi } from "../../../../../hooks/categoriasApi.ts";
import { produtosApi } from "../../../../../hooks/produtosApi.ts";
import Form from "../../../../../components/Form";
import { Toggle } from "../../../../../components/Toggle/Toggle.tsx";
import Titulo from "../../../../../components/Modal/ModaisConfigsPrimeiroAcesso/Titulo/Titulo.tsx";
import { boolean } from "../../../../../services/Functions.tsx";
import Modal from "../../../../../components/Modal/Modal.tsx";
import { Player, Controls } from "@lottiefiles/react-lottie-player";
import Error from "../../../../../assets/jsons/Error.json";
import { ModalReativar } from "./styles.ts";
import {
  CriarCategoriaContainer,
  ContainerEditarListas,
  Botoes,
} from "./styles.ts";
import { useTheme } from "../../../../../contexts/Theme/ThemeContext.tsx";
import Swal from "sweetalert2";
import ImageUploadCategoria from "../../../../../components/Upload/ImageUploadCategoria/ImageUploadCategoria.tsx";
import Loading from "../../../../../components/Loading/Loading.tsx";
import Table from "../../../../../components/Table/Table.tsx";
import { Select } from "../../../../../components/Select/index";
import { Categoria } from "../../../../../types/Categoria.ts";
import { ReactComponent as Plus } from "../../../../../assets/newImages/icons/plus.svg";
import { ReactComponent as LockSvg } from "../../../../../assets/newImages/icons/lock.svg";
import { useNavigate } from "react-router-dom";

interface CategoriaBoxProps {
  config_integracao: {
    permitir_produtos: boolean,
    permitir_imagens: boolean,
    permitir_observacoes: boolean,
  };
  onCategoriasChange: () => void;
  permissoesPlano: any;
}

type ViewMode = "listagem" | "form";
type TipoCategoria = "principal" | "subcategoria";

export const CategoriaBox: React.FC<CategoriaBoxProps> = ({
  config_integracao,
  onCategoriasChange,
  permissoesPlano,
}) => {
  const { theme } = useTheme();
  const api = categoriasApi();
  const navigate = useNavigate();
  const permiteSubcategorias = permissoesPlano?.SUBCATEGORIAS?.permitido;

  // Estado da view
  const [view, setView] = useState<ViewMode>("listagem");
  const [initialLoading, setInitialLoading] = useState(true);
  const [loading, setLoading] = useState(false);

  // Dados
  const [categorias, setCategorias] = useState<Categoria[]>([]);

  // Form
  const [editandoId, setEditandoId] = useState<number>(0);
  const [tipoCategoria, setTipoCategoria] = useState<TipoCategoria>("principal");
  const [nome, setNome] = useState("");
  const [imagem, setImagem] = useState("");
  const [idPastaPai, setIdPastaPai] = useState<number>(0);

  // Reativação
  const [modalReativar, setModalReativar] = useState(false);
  const [reativarProdutos, setReativarProdutos] = useState(false);
  const [qtdReativando, setQtdReativando] = useState(0);

  // Carregar categorias
  const carregarCategorias = async () => {
    const result = await produtosApi().getCategorias();
    setCategorias(result);
  };

  useEffect(() => {
    const init = async () => {
      setInitialLoading(true);
      await carregarCategorias();
      setInitialLoading(false);
    };
    init();
  }, []);

  // Categorias pai (id_pasta_pai === 0 ou "0")
  const categoriasPai = categorias.filter((c) => Number(c.id_pasta_pai) === 0);

  // Ordenar: pais alfabéticos, subcategorias logo abaixo do pai
  const categoriasOrdenadas = (() => {
    const pais = categoriasPai.sort((a, b) =>
      a.descricao.localeCompare(b.descricao)
    );
    const result: Categoria[] = [];
    for (const pai of pais) {
      const subs = categorias
        .filter((c) => String(c.id_pasta_pai) === String(pai.id))
        .sort((a, b) => a.descricao.localeCompare(b.descricao));
      const subsTotal = subs.reduce((sum, s) => sum + Number(s.qtd_produtos || 0), 0);
      result.push({
        ...pai,
        qtd_produtos: String(Number(pai.qtd_produtos || 0) + subsTotal),
      });
      result.push(...subs);
    }
    return result;
  })();

  // Abrir form para criar
  const abrirFormCriar = () => {
    setEditandoId(0);
    setTipoCategoria("principal");
    setNome("");
    setImagem("");
    setIdPastaPai(0);
    setView("form");
  };

  // Abrir form para editar
  const abrirFormEditar = (cat: Categoria) => {
    setEditandoId(Number(cat.id));
    setNome(cat.descricao);
    setImagem(cat.imagem || "");
    if (Number(cat.id_pasta_pai) > 0) {
      setTipoCategoria("subcategoria");
      setIdPastaPai(Number(cat.id_pasta_pai));
    } else {
      setTipoCategoria("principal");
      setIdPastaPai(0);
    }
    setView("form");
  };

  // Salvar (criar ou editar)
  const handleSalvar = async (reativar_produtos = false) => {
    if (nome.length === 0) return;

    const id_pasta_pai_final = tipoCategoria === "subcategoria" ? idPastaPai : 0;

    // Validar imagem para categoria principal
    if (tipoCategoria === "principal" && !imagem) {
      Swal.fire({
        icon: "error",
        title: "Adicione uma capa",
        text: "É necessário adicionar uma capa para a categoria.",
      });
      return;
    }

    // Verificar limite de plano (só para criação)
    if (editandoId === 0 && permissoesPlano?.CATEGORIAS) {
      if (permissoesPlano.CATEGORIAS.limitador < categorias.length + 1) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Você atingiu o limite de categorias permitidas no seu plano.",
        });
        return;
      }
    }

    setLoading(true);

    try {
      // Verificar nome duplicado (criação e edição)
      const verificacao = await api.verificarNomeCategoria(nome, editandoId, id_pasta_pai_final);
      if (verificacao.pastas_iguais) {
        if (editandoId === 0 && !reativar_produtos) {
          // Criação: oferecer reativação
          setQtdReativando(Number(verificacao.quantidades_produtos));
          setModalReativar(true);
          setLoading(false);
          return;
        } else if (editandoId > 0) {
          // Edição: bloquear nome duplicado
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Já existe uma categoria com esse nome.",
          });
          setLoading(false);
          return;
        }
      }

      // Salvar
      await api.salvarCategoria({
        id: editandoId,
        descricao: nome,
        imagem: tipoCategoria === "principal" ? imagem : undefined,
        id_pasta_pai: id_pasta_pai_final,
        reativar_produtos: reativarProdutos,
      });

      await carregarCategorias();
      onCategoriasChange();
      setView("listagem");
    } catch (error) {
      console.error(error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Ocorreu um erro ao salvar a categoria.",
      });
    } finally {
      setLoading(false);
    }
  };

  // Desativar categoria (com countdown se tem produtos)
  const handleDesativar = async (cat: Categoria) => {
    const temProdutos = Number(cat.qtd_produtos) > 0;
    const ehPai = Number(cat.id_pasta_pai) === 0;
    const subsCount = categorias.filter(
      (c) => String(c.id_pasta_pai) === String(cat.id)
    ).length;

    if (temProdutos || (ehPai && subsCount > 0)) {
      let textoAviso = "Atenção, todos os produtos vinculados a ela serão inativados e não ficarão mais disponíveis nos catálogos, para compra.";
      if (ehPai && subsCount > 0) {
        textoAviso = `Atenção, esta categoria possui ${subsCount} subcategoria(s). Todas as subcategorias e seus produtos serão inativados.`;
      }

      const result1 = await Swal.fire({
        icon: "error",
        title: "Tem certeza que deseja inativar esta categoria?",
        text: textoAviso,
        showCancelButton: true,
        confirmButtonText: "Inativar",
        cancelButtonText: "Cancelar",
        customClass: {
          confirmButton: "btn-confirm",
          icon: "custom-swal-icon",
        },
      });

      if (!result1.isConfirmed) return;

      let secondsLeft = 5;
      const result2 = await Swal.fire({
        title: "Deseja inativar?",
        text: "Poderá reativar essa categoria posteriormente, em Meus Produtos - Categorias e criando uma nova com o mesmo nome dessa.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Inativar (5)",
        cancelButtonText: "Cancelar",
        customClass: {
          confirmButton: "btn-confirm2",
          popup: "custom-swal-popup",
          icon: "custom-swal-icon",
          title: "custom-swal-title",
        },
        didOpen: () => {
          const confirmButton = Swal.getConfirmButton();
          if (confirmButton) {
            confirmButton.disabled = true;
            const timerInterval = setInterval(() => {
              secondsLeft--;
              confirmButton.innerText = `Inativar (${secondsLeft})`;
              if (secondsLeft <= 0) {
                confirmButton.disabled = false;
                confirmButton.innerText = "Inativar";
                clearInterval(timerInterval);
              }
            }, 1000);
          }
        },
      });

      if (!result2.value) return;
    }

    try {
      await api.removerCategoria(Number(cat.id));
      await carregarCategorias();
      onCategoriasChange();
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Erro",
        text: "Ocorreu um erro ao inativar a categoria.",
      });
    }
  };

  if (initialLoading) {
    return <div><Loading relative={true} /></div>;
  }

  // ==================== VIEW: FORM ====================
  if (view === "form") {
    const opcoesCategoriaPai = categoriasPai
      .filter((c) => Number(c.id) !== editandoId)
      .map((c) => ({ name: c.descricao, value: String(c.id) }));

    return (
      <CriarCategoriaContainer theme={theme}>
        <div className="descricao-categoria fonteTexto">
          Configure e gerencie as categorias da sua conta. Para criar categorias em dois níveis, crie primeiro a categoria principal e depois a subcategoria.
        </div>

        {/* Tipo de categoria */}
        <div style={{ marginBottom: "16px" }}>
          <Select
            label="Tipo de categoria"
            value={tipoCategoria}
            onChange={(val: string) => {
              if (val === "subcategoria" && !permiteSubcategorias) {
                navigate("/perfil/usuarios/planos");
                return;
              }
              setTipoCategoria(val as TipoCategoria);
              if (val === "principal") setIdPastaPai(0);
            }}
            options={[
              { name: "Principal", value: "principal" },
              {
                name: permiteSubcategorias
                  ? "Subcategoria"
                  : "Subcategoria (disponível a partir do plano Essencial)",
                value: "subcategoria",
                ...(!permiteSubcategorias && {
                  icon: <LockSvg style={{ width: "2rem", height: "2rem", marginRight: "0.5rem" }} />,
                }),
              },
            ]}
            disabled={!config_integracao.permitir_produtos || editandoId > 0}
          />
        </div>

        {/* Se subcategoria, select do pai */}
        {tipoCategoria === "subcategoria" && (
          <div style={{ marginBottom: "16px" }}>
            <Select
              label="Selecione a categoria principal"
              value={String(idPastaPai)}
              onChange={(val: string) => setIdPastaPai(Number(val))}
              options={opcoesCategoriaPai}
              placeholder="Nome"
              disabled={!config_integracao.permitir_produtos || editandoId > 0}
              required={true}
            />
          </div>
        )}

        {/* Imagem + Nome */}
        <div className="inputs">
          {tipoCategoria === "principal" && (
            <ImageUploadCategoria
              value={imagem}
              onChange={(base64: string, imagem: string, size: number) => {
                setImagem(base64);
              }}
            />
          )}
          <div className="input">
            <Input
              label={tipoCategoria === "subcategoria" ? "Nome da subcategoria" : "Nome da categoria"}
              disabled={!config_integracao.permitir_produtos}
              type="text"
              maxLength={64}
              name="nome"
              value={nome}
              allowEmojis={true}
              onChange={(newValue: string) => {
                setNome(newValue);
              }}
              placeholder="Nome"
            />
          </div>
        </div>

        <div className="botoes">
          <div
            className="cancelar fonteTexto"
            onClick={() => setView("listagem")}
          >
            <Voltar /> Voltar
          </div>
          <Button
            title={editandoId > 0 ? "Salvar" : (tipoCategoria === "subcategoria" ? "Criar subcategoria" : "Criar categoria")}
            loading={loading}
            className="botao_alterar fonteTexto"
            onClick={() => handleSalvar()}
            disabled={nome.length === 0 || (tipoCategoria === "subcategoria" && idPastaPai === 0)}
          />
        </div>

        {/* Modal de reativação */}
        <Modal
          isOpen={modalReativar}
          setModal={() => setModalReativar}
          children={
            <ModalReativar theme={theme}>
              <Player
                autoplay
                loop
                src={Error}
                style={{ height: "80px", width: "80px" }}
              >
                <Controls
                  visible={false}
                  buttons={["play", "repeat", "frame", "debug"]}
                />
              </Player>
              <div className="texto fonteTexto">
                <strong className="fonteTexto">
                  Ops, já existe uma categoria com o nome {`"${nome}"`}{" "}
                  <br />
                  Você gostaria de reativá-la?
                </strong>
              </div>
              {qtdReativando > 0 && (
                <div className="reativar">
                  <input
                    checked={reativarProdutos}
                    type="checkbox"
                    onChange={(e) => {
                      setReativarProdutos(e.target.checked);
                    }}
                  />
                  <span className="fonteRotulos">
                    Quero também reativar os {qtdReativando} produto(s) vinculado(s) a ela.
                  </span>
                </div>
              )}
              <Botoes theme={theme}>
                <div
                  className="cancelar fonteTexto"
                  onClick={() => {
                    setModalReativar(false);
                    setReativarProdutos(false);
                  }}
                >
                  <Voltar /> Voltar
                </div>
                <Button
                  title="Reativar"
                  type="button"
                  onClick={() => {
                    setModalReativar(false);
                    handleSalvar(true);
                    setReativarProdutos(false);
                  }}
                  width="50%"
                  className="botao_alterar fonteTexto"
                />
              </Botoes>
            </ModalReativar>
          }
          width="35vw"
          align="center"
          justify="center"
          animation="opacity 400ms cubic-bezier(0.4, 0, 0.2, 1)"
          margin="0rem 2rem 0rem 2rem"
        />
      </CriarCategoriaContainer>
    );
  }

  // ==================== VIEW: LISTAGEM ====================
  return (
    <ContainerEditarListas theme={theme}>
      <div className="descricao-categoria fonteTexto">
        Configure e gerencie as categorias da sua conta. Para criar categorias em dois níveis, crie primeiro a categoria principal e depois a subcategoria.
      </div>

      {config_integracao.permitir_produtos && (
        <div className="mais fonteTexto" onClick={abrirFormCriar}>
          <Plus className="plus" />
          <b>Adicionar nova categoria</b>
        </div>
      )}
      {categoriasOrdenadas.length > 0 && (
        <Table
          className="tabela-listagem-categorias"
          columns={[
            {
              key: "displayName",
              label: "Nome",
              mask: (value: any) => value,
            },
            {
              key: "qtd_produtos",
              label: "Produtos",
            },
            {
              key: "situacao",
              label: "Situação",
              mask: (value: any) => value,
            },
          ]}
          data={categoriasOrdenadas.map((cat) => ({
            ...cat,
            displayName: Number(cat.id_pasta_pai) === 0 ? (
              <span className="fonteTexto">{cat.descricao}</span>
            ) : (
              <span className="fonteTexto">
                <span style={{ color: "#999" }}>
                  {categorias.find((c) => String(c.id) === String(cat.id_pasta_pai))?.descricao + " / " || ""}
                </span>
                {cat.descricao}
              </span>
            ),
            situacao: (
              <div className="toggle-situacao" style={{ gap: "10px" }}>
                <Toggle
                  value={boolean(cat.ativo)}
                  isValid={true}
                  invalidText=""
                  disabled={!config_integracao.permitir_produtos}
                  onChange={async (newValue: boolean) => {
                    if (!newValue) {
                      handleDesativar(cat);
                    }
                  }}
                />
                <span
                  onClick={() => abrirFormEditar(cat)}
                  className="editar fonteTexto"
                  style={{ cursor: "pointer" }}
                >
                  Editar
                </span>
              </div>
            ),
          }))}
          sortable={false}
          selectable={false}
          button={false}
          page={1}
          itensPorPagina={-1}
          fitToViewportHeight
        />
      )}
    </ContainerEditarListas>
  );
};
